module.exports = __webpack_public_path__ + "static/media/zjc.9c431208.png";